import React from 'react';
import { Box, Grid, InputAdornment, TextField } from '@mui/material';
import { EmailOutlined as EmailIcon } from '@mui/icons-material';
import { connect } from 'react-redux';
import { setUser } from '../../store/actions/user';
import TextFieldPassword from '../TextFieldPassword';
import { useFormikContext } from 'formik';

const LoginMenu = () => {
    const formik = useFormikContext();

    return (
        <Box id="login-menu-id">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextField
                        id="email"
                        type="email"
                        label="Email Address"
                        variant="outlined"
                        value={formik.values.email}
                        onChange={formik.handleChange('email')}
                        onBlur={formik.handleBlur('email')}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={formik.touched.email && formik.errors.email}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <EmailIcon color="action" />
                                </InputAdornment>
                            ),
                        }}
                        fullWidth
                        required
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextFieldPassword variant="outlined" />
                </Grid>
            </Grid>
        </Box>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        userUpdate: (user) => dispatch(setUser(user)),
    };
};

export default connect(null, mapDispatchToProps)(LoginMenu);
